/* js/components/Splash.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	attr,
	create_out_transition,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal
} from "svelte/internal";

import { fade } from 'svelte/transition';

function create_fragment(ctx) {
	let div3;
	let div3_outro;
	let current;

	return {
		c() {
			div3 = element("div");

			div3.innerHTML = `<h1 class="svelte-1kan0hi">hypercity</h1> 



            <div class="splash-footer svelte-1kan0hi"><div class="logo-bm svelte-1kan0hi"><img class="logo svelte-1kan0hi" src="/images/logo_bm.png" alt=""/></div> 

            <div class="logo-ville svelte-1kan0hi"><img class="logo svelte-1kan0hi" src="/images/logo_ville.png" alt=""/></div></div>`;

			attr(div3, "class", "splash svelte-1kan0hi");
		},
		m(target, anchor) {
			insert(target, div3, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			if (div3_outro) div3_outro.end(1);
			current = true;
		},
		o(local) {
			div3_outro = create_out_transition(div3, fade, {});
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div3);
			if (detaching && div3_outro) div3_outro.end();
		}
	};
}

class Splash extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Splash;